import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import initialState from "./initialState";
import ACTION_NAMES from "actions/ACTION_NAMES";

const campaignSessionSummary = (state = initialState, action) => {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.CAMPAIGN_SESSION_SUMMARY, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingSessionSummary: true, sessionSummary: [], sessionSummaryCount: 0 };
        case getNamedAction(ACTION_NAMES.CAMPAIGN_SESSION_SUMMARY, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            return { ...state, isReadingSessionSummary: false, sessionSummary: action.data.data, sessionSummaryCount: action.data.count };
        case getNamedAction(ACTION_NAMES.CAMPAIGN_SESSION_SUMMARY, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, isReadingSessionSummary: false, sessionSummary: [], sessionSummaryCount: 0 };

        case getNamedAction(ACTION_NAMES.TEXT_CAMPAIGN_SESSION_SUMMARY, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingTextCampaignSessionSummary: true, textCampaignSessionSummary: [], textCampaignSessionSummaryCount: 0 };
        case getNamedAction(ACTION_NAMES.TEXT_CAMPAIGN_SESSION_SUMMARY, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            return { ...state, isReadingTextCampaignSessionSummary: false, textCampaignSessionSummary: action.data.data, textCampaignSessionSummaryCount: action.data.count };
        case getNamedAction(ACTION_NAMES.TEXT_CAMPAIGN_SESSION_SUMMARY, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, isReadingTextCampaignSessionSummary: false, textCampaignSessionSummary: [], textCampaignSessionSummaryCount: 0 };

        default:
            return state;
    }
}

export default campaignSessionSummary;
